import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import Services from '../components/Services';

class ServicePage extends Component {
  static propTypes = {
    services: PropTypes.array.isRequired
  }

  static defaultProps = {
    services: []
  }

  render() {
    var services = this.props.services;
    return (
      <Services entities={ services } />
      );
  }
}

ServicePage = connectToStores(ServicePage, ['ServiceStore'], (stores, props) => {

  return {
    services: stores.ServiceStore.get()
  };
});

export default ServicePage;


// WEBPACK FOOTER //
// ./src/pages/ServicePage.js